import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ExquisiteSurfaceArtistry() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="37355" id="thoughtful-home-cleaning" ref={sectionRef} className="relative w-full bg-background overflow-hidden">
      <div className="flex flex-col lg:flex-row min-h-[850px]">
        {}
        <div className="relative w-full lg:w-[55%] h-[500px] lg:h-auto">
          <div className={`absolute inset-0 bg-muted transition-opacity duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
             <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623166/img/winter-park-living-room.png" alt="Bright Winter Park living room with white linen sofas and natural light" className="w-full h-full object-cover" />
            {}
            <div className="absolute inset-0 bg-white/5" />
          </div>
        </div>

        {}
        <div className="relative w-full lg:w-[45%] bg-background flex items-center justify-center lg:justify-start p-6 lg:p-0">
          {}
          <div className={`
              relative z-10 w-full max-w-xl 
              lg:-ml-24 xl:-ml-32 
              -mt-16 lg:mt-0
              transition-all duration-1000 delay-300 ease-out
              ${isVisible ? 'opacity-100 translate-y-0 lg:translate-x-0' : 'opacity-0 translate-y-10 lg:translate-x-10'}
            `}>
            <Card className="bg-secondary border-none shadow-xl rounded-2xl overflow-hidden">
              <CardContent className="p-8 md:p-12 flex flex-col gap-6">
                <h1 className="text-4xl md:text-5xl lg:text-6xl font-default tracking-tight text-foreground">
                  Thoughtful Home Cleaning in Winter Park
                </h1>
                
                <div className="space-y-4 text-foreground/80 text-base md:text-lg leading-relaxed font-default">
                  <p>
                    Fast, reliable, detail-focused cleaning you can trust.
                  </p>
                  <p>
                    A calm, elevated cleaning experience designed for homes that value comfort, detail, and consistency.
                  </p>
                </div>

                <div className="pt-4">
                  <Button asChild size="lg" className="w-full sm:w-auto bg-primary border border-primary text-primary-foreground hover:bg-primary/90 hover:border-primary/90 transition-all duration-300 rounded-full px-8 py-6 text-base">
                    <Link to="#">
                      Get My Quote
                      <ArrowRight className="ml-2 h-4 w-4" />
                    </Link>
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}